import { render, staticRenderFns } from "./SelectFieldsModel.vue?vue&type=template&id=4e765ac1&"
import script from "./SelectFieldsModel.vue?vue&type=script&lang=js&"
export * from "./SelectFieldsModel.vue?vue&type=script&lang=js&"
import style0 from "./SelectFieldsModel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports